// React
import React from 'react';

// Packages

// Utilities
import { useActivityTagging } from 'utilities/hooks';
import { CONSTANTS } from 'utilities/configuration';

// Components
import {
    ActivityMetrics,
    ActivityReflections,
    ActivityDetails,
    ActivityChoice,
    ActivityDataCard,
    ActivitySetFieldValues,
} from '../_common';

const Name = CONSTANTS.ACTIVITIES.INTERVENTION;

const Choice = props => {
    return ActivityChoice({
        Name: `${Name}___Basic`,
        ...props,
    });
};

const DataCard = ({ item, theme = 'teal', mode = [] }) => {
    return (
        <ActivityDataCard
            {...{
                item,
                theme,
                tagTypes: [CONSTANTS.TAGS.INTERVENTION_ACTIVITY],
                showTags: mode.includes('tags'),
                showDetails: mode.includes('details'),
            }}
        />
    );
};

const Details = props => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const tagging = useActivityTagging({
        types: [CONSTANTS.TAGS.INTERVENTION_ACTIVITY],
    });

    // ///////////////////
    // RETURN
    // ///////////////////

    return ActivityDetails({
        tagging: tagging.activity,
        ...props,
    });
};

const Metrics = props => {
    return ActivityMetrics({
        Name,
        additional: true,
        allowSkipMetrics: true,
        ...props,
    });
};

const Reflections = props => {
    return ActivityReflections({
        additional: true,
        ...props,
    });
};

const setFieldValues = ({
    tagging,
    choice,
    form,
    id,
    utilities,
    REPORT_ID,
}) => {
    // ///////////////////
    // ALL THE OTHER STUFF
    // ///////////////////

    ActivitySetFieldValues({
        REPORT_ID,
        tagging,
        choice,
        form,
        id,
        utilities,
    });
};

export {
    Name,
    DataCard,
    Choice,
    Details,
    Metrics,
    Reflections,
    setFieldValues,
};
